import React, { ReactNode, useState } from "react";
import className from "classnames";

import SectionHeader from "./SectionHeader";

type Props = {
  children: ReactNode;
  headerTitle: ReactNode;
  abilityToClose?: boolean;
  theme?: string;
  readOnlyTheme?: boolean;
  sectionTitleWithBtn?: boolean;
  onHide?: Function;
  defaultCollapsed?: boolean;
};

const SectionContainer: React.FC<Props> = (props: Props) => {
  const { children, headerTitle, theme, abilityToClose = false, defaultCollapsed = false, sectionTitleWithBtn, readOnlyTheme = false, onHide } = props;

  const wrapperClasses = className({ "read-only-form-page-wrapper": readOnlyTheme });

  const [collapseSection, setCollapseSection] = useState(defaultCollapsed);

  const closeSectionContainer = (): void => {
    if (abilityToClose) {
      if (onHide) onHide(collapseSection);
      setCollapseSection(!collapseSection);
    }
  };

  const containerClass = className("section-container-wrapper", theme, { "section-container-wrapper-close": collapseSection });

  return (
    <div className={containerClass}>
      <div className={wrapperClasses}>
        <SectionHeader
          onClick={closeSectionContainer}
          collapseSection={collapseSection}
          headerTitle={headerTitle}
          abilityToClose={abilityToClose}
          sectionTitleWithBtn={sectionTitleWithBtn}
        />
      </div>
      <div className="section-container-content section-container-header-close">{children}</div>
    </div>
  );
};

export default SectionContainer;
